import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungKoblenz() {
  return (
    <CityPageTemplate
      city="Koblenz"
      slug="koblenz"
      intro="Koblenz am Deutschen Eck – wo Rhein und Mosel zusammenfließen, bringen wir auch Deine Finanzen zusammen."
      description="Unabhängige & digitale Finanzberatung für Koblenz: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
